// @ts-nocheck
import React from 'react'
import { Wrapper } from './styles'

const BlackFade: React.FC<{ onClick?: Function; className?: string }> = ({ onClick, className }) => {
  return <Wrapper onClick={onClick} className={className}></Wrapper>
}

export default BlackFade
